import MainRoutes from "./component/Routes/MainRoutes";




function App() {
  return (
    <div className="App">

      <MainRoutes />

    </div>
  );
}

export default App;
